/* ============================================================
   Jayone PDP — "More in …" carousel controls (ADR 0033)
   ============================================================
   Progressive enhancement for sections/section-jayone-product-related.liquid.
   Without this file the row is still a native scroll-snap track (swipe,
   trackpad, shift+wheel, keyboard through the tile links) — this only adds the
   prev/next buttons and keeps their state honest:
     - revealed from 750px up on a device that can hover with a fine pointer
       (mouse / trackpad — a touch screen swipes), AND only when the row really
       overflows. Was ≥1024px only: a 750–1023px desktop window or a tablet with
       a mouse saw 3¼ tiles and no way to move on but shift+wheel (fixer
       2026-09-29).
     - aria-disabled (not `disabled`) at either end, so a keyboard user's focus
       is never dropped to <body> when the last page is reached
     - one click moves one "page" of whole tiles
     - smooth scrolling unless the visitor asked the OS to reduce motion
   Re-evaluates on scroll, resize, and the `jayone:carousel:update` event the
   partner brand-mate swap dispatches after it replaces the tiles.
   ============================================================ */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setDisabled(btn, off) {
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
  }

  function init(root) {
    if (root.hasAttribute('data-jayone-carousel-ready')) return;
    var track = root.querySelector('[data-jayone-carousel-track]');
    var nav = root.querySelector('[data-jayone-carousel-nav]');
    var prev = root.querySelector('[data-jayone-carousel-prev]');
    var next = root.querySelector('[data-jayone-carousel-next]');
    if (!track || !nav || !prev || !next) return;
    root.setAttribute('data-jayone-carousel-ready', '');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflows = max > 1;
      nav.hidden = !(overflows && desktop.matches);
      setDisabled(prev, track.scrollLeft <= 1);
      setDisabled(next, track.scrollLeft >= max - 1);
    }

    function page(dir) {
      var item = track.querySelector('.jayone-product-related__item');
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      var perPage = Math.max(1, Math.floor((track.clientWidth + gap) / step));
      track.scrollBy({ left: dir * perPage * step, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () {
      if (prev.getAttribute('aria-disabled') === 'true') return;
      page(-1);
    });
    next.addEventListener('click', function () {
      if (next.getAttribute('aria-disabled') === 'true') return;
      page(1);
    });

    var frame = 0;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        update();
      });
    }, { passive: true });

    window.addEventListener('resize', update);
    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', update);
    }
    root.addEventListener('jayone:carousel:update', update);
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    }
    update();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-jayone-carousel]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', initAll);
})();
